/**
 * RUG SIZE GUIDE — compact "select" chrome + CTA compatibility bridge.
 * Keeps the existing select UI, syncs its closed-state values, and makes the
 * dynamically rendered CTA use the theme's native button system.
 */
(() => {
  if (window.__rugGuideSelect) return;
  window.__rugGuideSelect = true;

  const all = (root, selector) => Array.from(root.querySelectorAll(selector));
  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  function valueOf(button) {
    if (!button) return '';
    return (button.dataset.rugSizeLabel || button.textContent || '').trim();
  }

  function syncOne(details) {
    const pressed = details.querySelector('.rug-sizeguide__chips button[aria-pressed="true"]');
    const valueEl = details.querySelector('.rug-sizeguide__select-value');
    if (valueEl && pressed) valueEl.textContent = valueOf(pressed);
  }

  function syncRoot(root) {
    all(root, '.rug-sizeguide__select').forEach(syncOne);
  }

  function scrollToMainSizePicker() {
    const target = document.querySelector('.shopify-section--rug-main-product .rug-size-picker');
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function chooseMainSize(root) {
    const selected = root.querySelector('[data-rug-guide-size][aria-pressed="true"]') || root.querySelector('[data-rug-guide-size]');
    if (!selected) {
      scrollToMainSizePicker();
      return;
    }

    const wantedId = normalize(selected.dataset.rugSizeOptionId);
    const wantedLabel = normalize(selected.dataset.rugSizeLabel || selected.textContent);
    const inputs = all(document, '.shopify-section--rug-main-product .rug-size-picker__input');

    const input = inputs.find((candidate) => {
      if (wantedId && normalize(candidate.value) === wantedId) return true;

      const item = candidate.closest('.rug-size-picker__item');
      const label = item && item.querySelector('.rug-size-picker__dim');
      return wantedLabel && normalize(label && label.textContent) === wantedLabel;
    });

    if (input && !input.disabled && !input.checked) input.click();

    scrollToMainSizePicker();
    window.setTimeout(scrollToMainSizePicker, 120);
    window.setTimeout(scrollToMainSizePicker, 450);
  }

  function normalizeCta(root) {
    if (root.closest('.rug-size-guide-modal')) {
      const verdict = root.querySelector('.rug-sizeguide__verdict');
      if (verdict) verdict.remove();
    }

    const cta = root.querySelector('[data-rug-guide-choose]');
    if (!cta) return;

    cta.classList.remove('rug-sizeguide__choose');
    cta.classList.add('button', 'w-full');
  }

  function observeCta(root) {
    const info = root.querySelector('[data-rug-guide-info]');
    if (!info) return;

    normalizeCta(root);

    if (info.dataset.rugGuideNativeCta === 'true') return;
    info.dataset.rugGuideNativeCta = 'true';

    new MutationObserver(() => normalizeCta(root)).observe(info, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('click', (event) => {
    const root = event.target.closest('[data-rug-guide]');
    if (!root) return;

    const chooseButton = event.target.closest('[data-rug-guide-choose]');
    if (chooseButton && !chooseButton.disabled) chooseMainSize(root);

    const clickedDetails = event.target.closest('.rug-sizeguide__select');
    const chipButton = event.target.closest('.rug-sizeguide__chips button');

    if (chipButton) {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          syncRoot(root);
          if (clickedDetails) clickedDetails.removeAttribute('open');
        });
      });
    }

    all(root, '.rug-sizeguide__select[open]').forEach((openDetails) => {
      if (openDetails !== clickedDetails) openDetails.removeAttribute('open');
    });
  });

  document.addEventListener('variant:change', () => {
    all(document, '[data-rug-guide]').forEach((root) => {
      window.requestAnimationFrame(() => syncRoot(root));
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    all(event.target, '[data-rug-guide]').forEach((root) => {
      syncRoot(root);
      observeCta(root);
    });
  });

  const start = () => all(document, '[data-rug-guide]').forEach((root) => {
    syncRoot(root);
    observeCta(root);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
